
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.034 46.412v17.555h17.554l35.11-35.11-17.555-17.555L.034 46.412zm15.318 12.152h-4.515v-5.4H5.435v-4.516l3.84-3.842 9.918 9.918-3.841 3.84zm21.142-40.086c.617 0 .926.308.926.927 0 .281-.098.52-.293.718L14.254 42.994a.974.974 0 01-.717.295c-.618 0-.927-.313-.927-.928 0-.281.097-.521.293-.719L35.775 18.77a.987.987 0 01.719-.292zM62.402 11.513l-9.916-9.874C51.418.571 50.138.034 48.646.034c-1.52 0-2.787.537-3.799 1.605L37.844 8.6 55.4 26.156l7.002-7.005c1.043-1.04 1.564-2.305 1.564-3.797-.001-1.463-.523-2.744-1.564-3.841z"}})])
          )
        }
      }
    